import angular, { ITimeoutService } from 'angular';

export const BtnCheckboxDirectiveModule = angular
  .module('acme.common.directive.btnCheckbox', [])
  .directive('btnCheckbox', [
    '$timeout',
    function BtnCheckboxDirectiveModule($timeout: ITimeoutService) {
      return {
        restrict: 'A',
        replace: true,
        scope: {},

        link: function ($scope, $element, $attrs) {
          // Modified after controller runs
          console.log('Btn checkbox: ' + $element);
          function triggerClickOnKeyPress(e) {
            console.log('Keypress: ', $(e.target));
            $timeout(function () {
              $(e.target).click();
            }, 10);
          }
          if ($element.attr('tabindex') === undefined) {
            $element.attr('tabindex', '0');
          }
          if ($element.attr('role') === undefined) {
            $element.attr('role', 'button');
          }
          $element.off('keypress', triggerClickOnKeyPress);
          $element.on('keypress', triggerClickOnKeyPress);
        },
      };
    },
  ]).name;
